<button
  *ngIf="isOwnProduct()"
  class="btn p-0"
  type="button"
  data-test-selector="crosses-options-button"
  [ngbPopover]="editCrossesOptions"
  popoverClass="cross-reference-options"
  placement="bottom-left"
  container="body"
>
  <i class="fa fa-ellipsis-v"></i>
</button>

<ng-template #editCrossesOptions>
  <div *ngIf="canPromote()">
    <button
      class="text-start text-muted btn btn-block p-0"
      data-test-selector="crosses-promote-button"
      (click)="onPromoteCross(crossReference)"
    >
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
      Promote Cross to Primary
    </button>
    <hr class="text-muted my-1" style="width: 100%" />
  </div>
  <div>
    <button
      class="text-start text-muted btn btn-block p-0"
      data-test-selector="crosses-remove-button"
      (click)="onRemoveCross(crossReference)"
    >
      <i class="far fa-trash" aria-hidden="true"></i>
      Remove Cross
    </button>
  </div>
</ng-template>
